// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-basket {
    width: 24px;
    height: 24px;
    position: relative;
    margin-right: 16px;
}

.header-basket .header-count {
    right: -10px;
    top: -10px;
}

.header-count {
    font-size: 12px;
    line-height: 16px;
    color: var(--color-white);
    position: absolute;
    top: 4px;
    height: 16px;
    min-width: 16px;
    right: -5px;
    background: var(--color-yellow-pink);
    text-align: center;
    border-radius: 8px;
}

.header-count:after {
    content: attr(data-header-basket-count);
}

.header-count[data-header-basket-count],
.header-count[data-header-basket-count]:after {
    content: attr(data-header-basket-count);
    display: inline-block;
}

.header-count[data-header-basket-count=""]:after,
.header-count[data-header-basket-count=""],
.header-count[data-header-basket-count="0"]:after,
.header-count[data-header-basket-count="0"],
.header-count:not([data-header-basket-count]):after,
.header-count:not([data-header-basket-count]) {
    display: none;
}


.header-basket {
    width: 24px;
    height: 24px;
    position: relative;
    margin-right: 16px;
}

.header-basket .header-count {
    right: -10px;
    top: -10px;
}

.header-count {
    font-size: 12px;
    line-height: 16px;
    color: var(--color-white);
    position: absolute;
    top: 4px;
    height: 16px;
    min-width: 16px;
    right: -5px;
    background: var(--color-yellow-pink);
    text-align: center;
    border-radius: 8px;
}

.header-count:after {
    content: attr(data-header-basket-count);
}

.header-count[data-header-basket-count],
.header-count[data-header-basket-count]:after {
    content: attr(data-header-basket-count);
    display: inline-block;
}

.header-count[data-header-basket-count=""]:after,
.header-count[data-header-basket-count=""],
.header-count[data-header-basket-count="0"]:after,
.header-count[data-header-basket-count="0"],
.header-count:not([data-header-basket-count]):after,
.header-count:not([data-header-basket-count]) {
    display: none;
}


.header-menu {
    display: flex;
    justify-content: stretch;
    align-items: center;
}

.header-menu > .nav {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    flex: 1 1 auto;
}

@media screen and (max-width: 1024px) {
    .header-menu > .nav,
    .nav {
        display: none;
    }
}

.header-menu > .nav > .nav-list {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    margin: 0;
    padding: 15px 0;
    flex: 1 1 auto;
}

.header-menu > .nav > .nav-list > .nav-item {
    flex: 0 0 auto;
    padding: 5px 25px;
    box-sizing: border-box;
}

.header-menu > .nav > .nav-list > .nav-item:first-child {
    flex: 1 1 auto;
    text-align: right;
}

.header-menu > .nav > .nav-list > .nav-item > .nav-dropdown {
    text-align: left;
}

.header-menu > .nav > .nav-list > .nav-item:last-child {
    flex: 1 1 auto;
    text-align: left;
}

.nav-item:hover .nav-dropdown {
    opacity: 1;
    visibility: visible;
}

.nav-link {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-main);
    text-transform: uppercase;
    padding: 10px 0;
    letter-spacing: .5px;
    -webkit-font-feature-settings: "lnum";
    font-feature-settings: "lnum";
    border-bottom: 1px solid transparent;
}

.nav-dropdown {
    position: absolute;
    /*top: 95%;*/
    left: 0;
    width: 100%;
    opacity: 0;
    visibility: hidden;
    background: var(--color-white);
    padding: 32px 24px 20px 24px;
    display: flex;
    justify-content: center;
    z-index: 20;
    box-shadow: 0 15px 10px 5px rgba(0, 0, 0, 0.2);
}

.nav-dropdown:hover {
    opacity: 1;
    visibility: visible;
    z-index: 10;
}

.nav-dropdown__list {
    width: 180px;
    margin-right: 48px;
}

.nav-dropdown__list:last-child {
    margin-right: 0;
}

.nav-dropdown__item {
    margin-bottom: 12px;
}

.nav-dropdown__item:first-child {
    font-family: "RalewaySemiBold";
}

.nav-dropdown__item:last-child {
    margin-bottom: 0;
}

.nav-dropdown__link {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-main);
}


.carousel.f-carousel .f-button.is-next {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 10px 5px rgba(100, 100, 100, 0.3);
    color: var(--color-granite);
}

.carousel.f-carousel .f-button.is-prev {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 10px 5px rgba(100, 100, 100, 0.3);
    color: var(--color-granite);
}

.index-slider {
    position: relative;
    overflow: hidden;
    box-shadow: 0 10px 20px #999;
    z-index: 10;
}

.index-slider__img {
    width: 100%;
    height: auto;
    -o-object-fit: contain;
    object-fit: contain;
    display: block;
}

.index-slider__pc {
    width: 100%;
    height: auto;
    -o-object-fit: contain;
    object-fit: contain;
    display: block;
}

@media screen and (max-width: 960px) {
    .index-slider__pc {
        display: none;
    }
}

.index-slider__mobile {
    display: none;
}

@media screen and (max-width: 960px) {
    .index-slider__mobile {
        width: 100%;
        height: auto;
        -o-object-fit: contain;
        object-fit: contain;
        display: block;
    }
}

.index-full {
    width: 100%;
    /*height: 640px;*/
}

@media screen and (max-width: 576px) {
    .index-full {
        /*height: 480px;*/
    }
}

.index-full .slider-container {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/main/main.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;;;;;;IAMI,aAAa;AACjB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;;;;;;IAMI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,eAAe;IACf,oBAAoB;IACpB,qCAAqC;IACrC,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,8BAA8B;IAC9B,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,iDAAiD;IACjD,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,iDAAiD;IACjD,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB,mBAAmB;QACnB,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".header-basket {\n    width: 24px;\n    height: 24px;\n    position: relative;\n    margin-right: 16px;\n}\n\n.header-basket .header-count {\n    right: -10px;\n    top: -10px;\n}\n\n.header-count {\n    font-size: 12px;\n    line-height: 16px;\n    color: var(--color-white);\n    position: absolute;\n    top: 4px;\n    height: 16px;\n    min-width: 16px;\n    right: -5px;\n    background: var(--color-yellow-pink);\n    text-align: center;\n    border-radius: 8px;\n}\n\n.header-count:after {\n    content: attr(data-header-basket-count);\n}\n\n.header-count[data-header-basket-count],\n.header-count[data-header-basket-count]:after {\n    content: attr(data-header-basket-count);\n    display: inline-block;\n}\n\n.header-count[data-header-basket-count=\"\"]:after,\n.header-count[data-header-basket-count=\"\"],\n.header-count[data-header-basket-count=\"0\"]:after,\n.header-count[data-header-basket-count=\"0\"],\n.header-count:not([data-header-basket-count]):after,\n.header-count:not([data-header-basket-count]) {\n    display: none;\n}\n\n\n.header-basket {\n    width: 24px;\n    height: 24px;\n    position: relative;\n    margin-right: 16px;\n}\n\n.header-basket .header-count {\n    right: -10px;\n    top: -10px;\n}\n\n.header-count {\n    font-size: 12px;\n    line-height: 16px;\n    color: var(--color-white);\n    position: absolute;\n    top: 4px;\n    height: 16px;\n    min-width: 16px;\n    right: -5px;\n    background: var(--color-yellow-pink);\n    text-align: center;\n    border-radius: 8px;\n}\n\n.header-count:after {\n    content: attr(data-header-basket-count);\n}\n\n.header-count[data-header-basket-count],\n.header-count[data-header-basket-count]:after {\n    content: attr(data-header-basket-count);\n    display: inline-block;\n}\n\n.header-count[data-header-basket-count=\"\"]:after,\n.header-count[data-header-basket-count=\"\"],\n.header-count[data-header-basket-count=\"0\"]:after,\n.header-count[data-header-basket-count=\"0\"],\n.header-count:not([data-header-basket-count]):after,\n.header-count:not([data-header-basket-count]) {\n    display: none;\n}\n\n\n.header-menu {\n    display: flex;\n    justify-content: stretch;\n    align-items: center;\n}\n\n.header-menu > .nav {\n    display: flex;\n    flex-direction: row;\n    justify-content: stretch;\n    flex: 1 1 auto;\n}\n\n@media screen and (max-width: 1024px) {\n    .header-menu > .nav,\n    .nav {\n        display: none;\n    }\n}\n\n.header-menu > .nav > .nav-list {\n    display: flex;\n    flex-direction: row;\n    justify-content: stretch;\n    margin: 0;\n    padding: 15px 0;\n    flex: 1 1 auto;\n}\n\n.header-menu > .nav > .nav-list > .nav-item {\n    flex: 0 0 auto;\n    padding: 5px 25px;\n    box-sizing: border-box;\n}\n\n.header-menu > .nav > .nav-list > .nav-item:first-child {\n    flex: 1 1 auto;\n    text-align: right;\n}\n\n.header-menu > .nav > .nav-list > .nav-item > .nav-dropdown {\n    text-align: left;\n}\n\n.header-menu > .nav > .nav-list > .nav-item:last-child {\n    flex: 1 1 auto;\n    text-align: left;\n}\n\n.nav-item:hover .nav-dropdown {\n    opacity: 1;\n    visibility: visible;\n}\n\n.nav-link {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-main);\n    text-transform: uppercase;\n    padding: 10px 0;\n    letter-spacing: .5px;\n    -webkit-font-feature-settings: \"lnum\";\n    font-feature-settings: \"lnum\";\n    border-bottom: 1px solid transparent;\n}\n\n.nav-dropdown {\n    position: absolute;\n    /*top: 95%;*/\n    left: 0;\n    width: 100%;\n    opacity: 0;\n    visibility: hidden;\n    background: var(--color-white);\n    padding: 32px 24px 20px 24px;\n    display: flex;\n    justify-content: center;\n    z-index: 20;\n    box-shadow: 0 15px 10px 5px rgba(0, 0, 0, 0.2);\n}\n\n.nav-dropdown:hover {\n    opacity: 1;\n    visibility: visible;\n    z-index: 10;\n}\n\n.nav-dropdown__list {\n    width: 180px;\n    margin-right: 48px;\n}\n\n.nav-dropdown__list:last-child {\n    margin-right: 0;\n}\n\n.nav-dropdown__item {\n    margin-bottom: 12px;\n}\n\n.nav-dropdown__item:first-child {\n    font-family: \"RalewaySemiBold\";\n}\n\n.nav-dropdown__item:last-child {\n    margin-bottom: 0;\n}\n\n.nav-dropdown__link {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-main);\n}\n\n\n.carousel.f-carousel .f-button.is-next {\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    background-color: rgba(255, 255, 255, 0.6);\n    box-shadow: 0 0 10px 5px rgba(100, 100, 100, 0.3);\n    color: var(--color-granite);\n}\n\n.carousel.f-carousel .f-button.is-prev {\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    background-color: rgba(255, 255, 255, 0.6);\n    box-shadow: 0 0 10px 5px rgba(100, 100, 100, 0.3);\n    color: var(--color-granite);\n}\n\n.index-slider {\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 10px 20px #999;\n    z-index: 10;\n}\n\n.index-slider__img {\n    width: 100%;\n    height: auto;\n    -o-object-fit: contain;\n    object-fit: contain;\n    display: block;\n}\n\n.index-slider__pc {\n    width: 100%;\n    height: auto;\n    -o-object-fit: contain;\n    object-fit: contain;\n    display: block;\n}\n\n@media screen and (max-width: 960px) {\n    .index-slider__pc {\n        display: none;\n    }\n}\n\n.index-slider__mobile {\n    display: none;\n}\n\n@media screen and (max-width: 960px) {\n    .index-slider__mobile {\n        width: 100%;\n        height: auto;\n        -o-object-fit: contain;\n        object-fit: contain;\n        display: block;\n    }\n}\n\n.index-full {\n    width: 100%;\n    /*height: 640px;*/\n}\n\n@media screen and (max-width: 576px) {\n    .index-full {\n        /*height: 480px;*/\n    }\n}\n\n.index-full .slider-container {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
